import React from "react";
import { Tooltip } from "antd";
import TooltipCard from "./TooltipCard"; // Adjust path
import { InfoIconSvg } from "../../common/CustomIcon";

const InfoTooltip = ({ label, icon, message }) => {
    
    return (
        <Tooltip
            overlayClassName="ToolTipCard"
            title={
                <TooltipCard
                    label={label}
                    icon={icon}
                    message={message}
                />
            }
            placement="bottomRight"
        >
            <span
                className="info-icon"
                style={{
                    display: "inline-block",
                    cursor: "pointer",
                    color: "#576ec1",
                }}
            >
                <InfoIconSvg
                    styling={{
                        width: 12,
                        height: 12
                    }}
                />
            </span>
        </Tooltip>
    );
};
export default InfoTooltip;